'use client';

import { useRouter } from 'next/navigation';
import { useTranslation } from 'next-i18next';

import { Button, StackProps, Text, VStack } from '@chakra-ui/react';

import { IconsLinear } from '@nocowanie/icons/linear';

export const ErrorInfo = ({ ...props }: StackProps) => {
    const { refresh } = useRouter();
    const { t } = useTranslation('listing', {
        keyPrefix: 'apiError',
    });

    return (
        <VStack gap={4} justifyContent={'center'} {...props}>
            <IconsLinear.InfoCircle
                color={'gray.600'}
                size={{
                    base: 'xl',
                    md: '2xl',
                }}
                css={{
                    '--icon-stroke': 1.5,
                }}
            />
            <Text fontWeight={'bold'} textStyle={{ base: 'xl', md: '2xl' }} textAlign={'center'}>
                {t('title')}
            </Text>
            <Text
                textAlign={'center'}
                css={{
                    '& br': {
                        display: {
                            base: 'none',
                            md: 'block',
                        },
                    },
                }}
                dangerouslySetInnerHTML={{
                    __html: t('message'),
                }}
            />
            <Button onClick={() => refresh()} variant={'solid'} w={{ base: 'full', md: 'auto' }}>
                {t('cta')}
            </Button>
        </VStack>
    );
};
